module.exports = __webpack_public_path__ + "static/media/no-custom-fields.7160396e.png";